import list from './list';
import { isSuperAdmin, isAdmin } from 'utils';

export default (permissions) => {
  // Super Admins and Admins only
  const isVisible = isSuperAdmin(permissions) || isAdmin(permissions);

  return {
    name: 'feedback',
    list: isVisible ? list : null,
    icon: 'comments',
    options: {
      menuIndex: 7,
      isHidden: !isVisible,
    },
  };
};
